import { Section, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import PayrollPolicyFormSelfService from 'modules/payroll_bundle/pages/settings/Components/PayrollPolicyFormSelfService'
import Content from 'modules/payroll_bundle/pages/settings/Content/PayrollPolicies/components/Content'

interface Props {
  policyEmployeeCounts: Map<number, number>
}

const PayrollPolicies = ({ policyEmployeeCounts }: Props) => {
  const [isModalOpen, toggleModal] = useToggle(false)

  return (
    <>
      <Section
        illustration="money-bag"
        title={i18n.t('payroll_bundle.policy_period.settings.title')}
        description={i18n.t('payroll_bundle.policy_period.settings.description_self_onboarding')}
        action={{
          label: i18n.t('app_store_v2.apps.payroll_bundle.settings.add'),
          onClick: toggleModal(true),
        }}
      >
        <Content policyEmployeeCounts={policyEmployeeCounts} />
      </Section>
      {isModalOpen && (
        <PayrollPolicyFormSelfService
          onClose={toggleModal(false)}
          contractVersions={contractVersions}
        />
      )}
    </>
  )
}

export default observer(PayrollPolicies)
